import React from 'react';

function AnimationShowcase() {
  return (
    <>
      {/* ░░ ANIMATION SHOWCASE ░░ */}
<section className="anim-section" id="videos">
  <div className="anim-inner">

    <div className="animate-on-scroll">
      <div className="section-eyebrow anim-eyebrow">See It In Action</div>
      <h2 className="section-h2 anim-h2">UPI transactions —<br /><em>animated in real time.</em></h2>
      <p className="section-lead anim-lead">Three live animations showing how SpeedVault processes every rupee — from scan to settlement.</p>
    </div>

    {/* Tab switcher */}
    <div className="anim-tabs animate-on-scroll" style={{transitionDelay: '.1s'}}>
      <button className="anim-tab active" data-tab="0">
        <span className="anim-tab-icon"><svg className="sv-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="5" y="5" width="3" height="3"/><rect x="16" y="5" width="3" height="3"/><rect x="16" y="16" width="3" height="3"/><rect x="5" y="16" width="3" height="3"/></svg></span>
        <span className="anim-tab-text">QR Scan &amp; Pay</span>
      </button>
      <button className="anim-tab" data-tab="1">
        <span className="anim-tab-icon"><svg className="sv-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg></span>
        <span className="anim-tab-text">Transaction Journey</span>
      </button>
      <button className="anim-tab" data-tab="2">
        <span className="anim-tab-icon"><svg className="sv-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></span>
        <span className="anim-tab-text">Fraud Detection</span>
      </button>
    </div>

    {/* Canvas panels */}
    <div className="anim-panels animate-on-scroll" style={{transitionDelay: '.2s'}}>

      {/* Panel 0: QR Scan */}
      <div className="anim-panel active" id="panel0">
        <div className="anim-panel-inner">
          <div className="anim-canvas-wrap">
            <canvas id="qrCanvas"></canvas>
          </div>
          <div className="anim-panel-info">
            <div className="anim-step-list" id="qrSteps">
              <div className="anim-step active" data-step="0">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">Customer opens UPI app</div>
                  <div className="anim-step-desc">App generates a secure onE-time session token linked to the customer's VPA.</div>
                </div>
              </div>
              <div className="anim-step" data-step="1">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">QR code scanned</div>
                  <div className="anim-step-desc">Merchant QR decoded instantly — amount, VPA, and merchant ID extracted in &lt;2ms.</div>
                </div>
              </div>
              <div className="anim-step" data-step="2">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">MPIN entered &amp; encrypted</div>
                  <div className="anim-step-desc">256-bit AES encryption applied before the PIN ever leaves the device.</div>
                </div>
              </div>
              <div className="anim-step" data-step="3">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">SpeedVault routes the request</div>
                  <div className="anim-step-desc">Our switch selects the optimal bank channel based on real-time health scores.</div>
                </div>
              </div>
              <div className="anim-step" data-step="4">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">Payment confirmed ✓</div>
                  <div className="anim-step-desc">Debit, credit, and notification delivered to both parties in under 500ms.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="anim-panel-stat-bar">
          <div className="anim-pstat"><span className="anim-pstat-n" id="qrTps">4,820</span><span className="anim-pstat-l">TPS right now</span></div>
          <div className="anim-pstat"><span className="anim-pstat-n">38ms</span><span className="anim-pstat-l">Avg. scan-to-confirm</span></div>
          <div className="anim-pstat"><span className="anim-pstat-n">99.99%</span><span className="anim-pstat-l">Success rate</span></div>
        </div>
      </div>

      {/* Panel 1: Transaction Journey */}
      <div className="anim-panel" id="panel1">
        <div className="anim-panel-inner">
          <div className="anim-canvas-wrap">
            <canvas id="journeyCanvas"></canvas>
          </div>
          <div className="anim-panel-info">
            <div className="anim-step-list" id="journeySteps">
              <div className="anim-step active" data-step="0">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">Payer initiates transfer</div>
                  <div className="anim-step-desc">₹12,500 from HDFC VPA → merchant VPA. Request encrypted and signed.</div>
                </div>
              </div>
              <div className="anim-step" data-step="1">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">SpeedVault Switch receives</div>
                  <div className="anim-step-desc">Request hits our switch in 6ms. Routing algorithm selects best path instantly.</div>
                </div>
              </div>
              <div className="anim-step" data-step="2">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">NPCI validates &amp; debits</div>
                  <div className="anim-step-desc">NPCI backend verifies, debit instruction sent to payer's bank — confirmed in 110ms.</div>
                </div>
              </div>
              <div className="anim-step" data-step="3">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">Credit to merchant</div>
                  <div className="anim-step-desc">Merchant bank receives credit instruction. Funds settled, receipt generated.</div>
                </div>
              </div>
              <div className="anim-step" data-step="4">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">Reconciliation logged</div>
                  <div className="anim-step-desc">Transaction appended to SpeedVault ledger. Reconciliation report updated live.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="anim-panel-stat-bar">
          <div className="anim-pstat"><span className="anim-pstat-n" id="jtxCount">1,247</span><span className="anim-pstat-l">Transactions this min</span></div>
          <div className="anim-pstat"><span className="anim-pstat-n">6ms</span><span className="anim-pstat-l">Switch latency</span></div>
          <div className="anim-pstat"><span className="anim-pstat-n">500+</span><span className="anim-pstat-l">Banks connected</span></div>
        </div>
      </div>

      {/* Panel 2: Fraud Detection */}
      <div className="anim-panel" id="panel2">
        <div className="anim-panel-inner">
          <div className="anim-canvas-wrap">
            <canvas id="fraudDetCanvas"></canvas>
          </div>
          <div className="anim-panel-info">
            <div className="anim-step-list" id="fraudSteps">
              <div className="anim-step active" data-step="0">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">Transaction received</div>
                  <div className="anim-step-desc">Every transaction enters SpeedVault's AI risk pipeline before touching the network.</div>
                </div>
              </div>
              <div className="anim-step" data-step="1">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">200+ risk signals checked</div>
                  <div className="anim-step-desc">Velocity, geo-location, device fingerprint, behavioural pattern — all scored in &lt;8ms.</div>
                </div>
              </div>
              <div className="anim-step" data-step="2">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">ML model scores transaction</div>
                  <div className="anim-step-desc">Trained on 10M+ UPI transactions. Anomaly score computed with 99.7% accuracy.</div>
                </div>
              </div>
              <div className="anim-step" data-step="3">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">Block or approve</div>
                  <div className="anim-step-desc">High-risk: blocked instantly + alert fired. Clean: routed within SLA. No manual review.</div>
                </div>
              </div>
              <div className="anim-step" data-step="4">
                <div className="anim-step-dot"></div>
                <div className="anim-step-content">
                  <div className="anim-step-title">Alert &amp; report generated</div>
                  <div className="anim-step-desc">Fraud case logged, webhook dispatched, dashboard updated — your team acts in seconds.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="anim-panel-stat-bar">
          <div className="anim-pstat"><span className="anim-pstat-n" id="fraudBlocked">1,247</span><span className="anim-pstat-l">Fraud blocked today</span></div>
          <div className="anim-pstat"><span className="anim-pstat-n">8ms</span><span className="anim-pstat-l">Detection latency</span></div>
          <div className="anim-pstat"><span className="anim-pstat-n">99.7%</span><span className="anim-pstat-l">Detection accuracy</span></div>
        </div>
      </div>

    </div>{/* end panels */}
  </div>
</section>
    </>
  );
}

export default AnimationShowcase;
